export default (document) => (Object.assign(Object.assign(Object.assign({}, document), { createdAt: new Date(document.createdAt) }), ("opinion" in document && document.opinion
    ? {
        metricType: document.opinion.metricType,
        doctor: document.opinion.doctor,
    }
    : {})));
